import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Gallery from 'react-photo-gallery';

import BuildSettings from 'APP_ROOT/components/buildSettings';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import { ModalLoadingPage } from 'APP_ROOT/components/common/loadingPage';
import Switch from 'APP_ROOT/components/common/Switch';
//import ConfirmDialog from 'APP_ROOT/components/common/ConfirmDialog';
import { LegacyConfirmDialog } from 'APP_ROOT/components/common/Modal2';
import SettingsSelectors from 'APP_ROOT/data/settings/selectors';
import { changeSetting } from 'APP_ROOT/data/settings/actions';
import identities from 'APP_ROOT/data/identities';
import globals from 'APP_ROOT/components/common/globals';

import FacesDataSource from './FacesDataSource';
import SelectableImage from './SelectableImage';
import FaceDetailModal from './FaceDetailModal';
import MergeDialog from './MergeDialog';
import DeleteDialog from './DeleteDialog';

const SelectablePhotoStack = SelectableImage({ baseClassName: 'photostack', showUnselectedCheck: true });
const PhotoStack = SelectableImage({ baseClassName: 'photostack', showUnselectedCheck: false });

export const ALL_MAIN_SECTIONS = {
    FACIAL_RECOGNITION: "FACIAL_RECOGNITION"
};

export const SUBSECTIONS_BY_MAIN_SECTION = {
    FACIAL_RECOGNITION: null
};

export const CallStatus = {
    IN_PROGRESS: 'in progress',
    SUCCESS: 'success',
    ERROR: 'error',
};

export class FacesSection extends Component {

    state = {
        confirmDialogOpen: false, // when enabling this feature, user must confirm they understand the implications.
        confirmDeleteDialogOpen: false,
        confirmMergeDialogOpen: false,
        actionStatus: {}, // { progressMessage, successMessage }
        selectedFaceIds: [],
        updateInProgress: '',
        detailIdentityId: undefined
    };

    componentDidMount() {
        this.getIdentities()
    }

    getIdentities = () => {
        this.props.loadAccountIdentities(this.props.user.stage);
    }

    deleteImages = (imagesToDelete) => {
        this.setState({
            actionStatus: { progressMessage: "Deleting Images" }
        });
        FacesDataSource.with(this.props.user)
            .deleteIdentityFaces(imagesToDelete)
            .then(result => {
                this.setState({
                    actionStatus: { successMessage: "Images Deleted" }
                });
                this.getIdentities();
            }).catch(err => {
                console.error("deleteIdentityFaces failed", err);
                this.setState({
                    actionStatus: { successMessage: "Delete Images Failed" }
                });
            });
    };

    unassignImages = (imagesToUnassign) => {
        this.setState({
            actionStatus: { progressMessage: "Unassigning Images" }
        });
        FacesDataSource.with(this.props.user)
            .unassignIdentityFaces(imagesToUnassign)
            .then(result => {
                const stage = this.props.user ? this.props.user.stage : undefined;
                const detailIdentityId = this.state.detailIdentityId;
                if (stage && detailIdentityId) {
                    this.props.loadDetailedIdentity(stage, detailIdentityId);
                }
                this.setState({
                    actionStatus: { successMessage: "Images Unassigned" }
                });
                this.getIdentities();
            }).catch(err => {
                console.error("unassignIdentityFaces failed", err);
                this.setState({
                    actionStatus: { successMessage: "Unassign Images Failed" }
                });
            });
    };

    setFaceName = (id, name) => {
        this.setState({
            actionStatus: { progressMessage: "Saving" }
        });
        FacesDataSource.with(this.props.user)
            .setIdentityName(parseInt(id), name)
            .then((response) => {
                this.closeFaceDetailModal();
                this.getIdentities();
                this.setState({
                    actionStatus: { successMessage: "" }
                });
            }).catch((error) => {
                console.error("setIdentityName failed", error);
                this.setState({
                    actionStatus: { errorMessage: "Save Failed" }
                });
            });
    }

    closeFaceDetailModal = () => {
        this.setState({
            detailIdentityId: null
        });
    }

    onRefreshClick = (e) => {
        e.preventDefault();
        this.props.loadAccountIdentities(this.props.user.stage);
    }

    toggleMembership = (array, elem) => {
        if (array.includes(elem)) {
            return array.filter(it => it !== elem);
        }
        return array.concat(elem);
    }

    onFaceClickEditMode = (faceId) => {
        this.setState(state => {
            return {
                selectedFaceIds: this.toggleMembership(state.selectedFaceIds, faceId)
            };
        });
    }

    onFaceClickNormal = detailIdentityId => {
        this.setState({ detailIdentityId });
    }

    confirmEnableFeature = () => {
        this.setState({
            confirmDialogOpen: true
        });
    }

    dismissConfirmEnableFeatureDialog = () => {
        this.setState({
            confirmDialogOpen: false
        });
    }

    updateFeatureEnabled = enabled => {
        this.setEditMode(false);
        this.setState({
            confirmDialogOpen: false,
            updateInProgress: enabled ? 'Enabling' : 'Disabling',
        });
        this.props.changeFacialRecognitionEnabled(this.props.user.stage, enabled).then(() => {
            if(enabled) this.getIdentities();
            this.setState({
                updateInProgress: '',
            });
        }).catch(err => {
            console.error('updateFeatureEnabled', err);
            this.setState({
                errorMessage: `Failed to ${enabled ? 'enable' : 'disable'} facial recognition on Raven`,
                updateInProgress: '',
            });
        });
    }

    setIdentityProfileFace = (identityId, faceId) => {
        this.setState({
            actionStatus: { progressMessage: "Setting Profile Image" }
        });
        return FacesDataSource.with(this.props.user)
            .setIdentityProfileFace(identityId, faceId)
            .then(res => {
                this.setState({
                    actionStatus: { successMessage: "Profile Image Updated" }
                });
                this.getIdentities();
            }).catch(err => {
                console.error('setIdentityProfileFace', err);
                this.setState({
                    actionStatus: { errorMessage: 'Failed to set profile image' }
                });
            });
    }

    selectMatchingFaces = predicate => {

        const { managedIdentitiesUnnamed, managedIdentitiesNamed } = this.props;
        const allFaces = [...managedIdentitiesUnnamed, ...managedIdentitiesNamed];

        this.setState(state => {
            return {
                selectedFaceIds: state.selectedFaceIds.concat(
                    allFaces.filter(
                        it => predicate(it) && !state.selectedFaceIds.includes(it.identityId)
                    ).map(
                        it => it.identityId
                    )
                )
            };
        });
    }

    selectAllNewFaces = () => {
        this.selectMatchingFaces(it => !it.name);
    }

    selectAllNamedFaces = () => {
        this.selectMatchingFaces(it => it.name);
    }

    confirmDelete = () => {
        this.setState({
            confirmDeleteDialogOpen: true
        });
    }

    cancelDelete = () => {
        this.setState({
            confirmDeleteDialogOpen: false
        });
    }

    deleteSelectedFaces = () => {
        this.setState({
            confirmDeleteDialogOpen: false,
            updateInProgress: 'Deleting',
        });
        FacesDataSource.with(this.props.user)
            .deleteIdentities(this.state.selectedFaceIds)
            .then(() => {
                this.getIdentities();
                this.setEditMode(false);
                this.setState({
                    updateInProgress: '',
                });
            }).catch(err => {
                console.error('error in deleteSelectedFaces', err);
                let errorMessage =  'An error occurred deleting faces';
                if (err && err.code === 'ResourceNotFoundException') {
                    errorMessage = 'Delete Faces is not supported';
                }
                this.setState({
                    errorMessage,
                    updateInProgress: ''
                });
            });
    }

    confirmMerge = () => {
        this.setState({
            confirmMergeDialogOpen: true
        });
    }

    cancelMerge = () => {
        this.setState({
            confirmMergeDialogOpen: false
        });
    }

    mergeIdentities = (mainIdentityId, otherIdentityId) => {
        this.closeFaceDetailModal();
        this.setState({
            updateInProgress: 'Merging'
        });
        FacesDataSource.with(this.props.user)
            .mergeIdentities([mainIdentityId, otherIdentityId])
            .then(() => {
                this.getIdentities();
                this.setState({
                    updateInProgress: ''
                });
            }).catch((error) => {
                console.error("mergeIdentities failed", error);
                this.setState({
                    updateInProgress: '',
                    errorMessage: 'An error occurred during merge'
                });
            });
    }

    mergeFaces = (faces) => {
        this.setState({
            confirmMergeDialogOpen: false,
            updateInProgress: 'Merging'
        });
        FacesDataSource.with(this.props.user)
            .mergeIdentities(faces.map(face => face.identityId))
            .then(() => {
                this.getIdentities();
                this.setEditMode(false);
                this.setState({
                    updateInProgress: ''
                });
            }).catch((error) => {
                console.error("mergeFaces failed", error);
                this.setState({
                    updateInProgress: '',
                    errorMessage: 'An error occurred during merge'
                });
            });
    }

    setEditMode = editMode => {
        this.setState({
            editMode,
            selectedFaceIds: []
        });
    }

    toggleEditMode = () => {
        this.setState(state => ({
            editMode: !state.editMode,
            selectedFaceIds: []
        }));
    }

    render() {

        const { facialRecognitionEnabledSetting, features } = this.props;

        // build features guard - is facial recognition supported at all for this deployment?
        if (!features || !features.facial_recognition) return null;

        // setting exists guard
        if(!facialRecognitionEnabledSetting) return null;

        const featureEnabled = facialRecognitionEnabledSetting.value;

        const featureEnabledChangePending = facialRecognitionEnabledSetting.pending;

        const {
            confirmDialogOpen,
            confirmDeleteDialogOpen,
            confirmMergeDialogOpen,
            actionStatus,
            updateInProgress,
            editMode,
            selectedFaceIds,
            detailIdentityId,
        } = this.state;

        const {
            fetchInProgress,
            managedIdentitiesNamed,
            managedIdentitiesUnnamed,
        } = this.props;

        // TODO 2020-02-14: finish moving responsibilities to redux, then just get errorMessage from props
        const errorMessage = this.state.errorMessage || this.props.errorMessage;

        let title = strings.formatString(strings.settings_global_facial_recognition_header);

        if (!featureEnabled) {
            return (
                <div className="row" id="component_document_id_facial_recognition">
                    <div className="col-12">
                        <h2>{title} <a href={BuildSettings.helpUrl('/fleet-managers-guide/#facial-recognition')} alt="Learn more about Facial Recognition" target="_blank" rel="noopener noreferrer"><i className="material-icons">help_outline</i></a></h2>
                    </div>
                    <div className="col-12">
                        <div className="settings-section">
                            <div className="alert alert-dark" role="alert">
                                {strings.facial_recognition_facial_recognition_is_not_enabled} <button className="alert-link" onClick={this.confirmEnableFeature}>{strings.racial_recognition_click_here_to_start_using_it}</button>
                            </div>
                            { errorMessage &&
                                    <div className="alert alert-warning" role="alert">
                                        {errorMessage}
                                    </div>
                            }
                        </div>
                        <LegacyConfirmDialog
                            isOpen={confirmDialogOpen}
                            contentLabel="confirm-delete-face"
                            onOk={() => this.updateFeatureEnabled(true)}
                            onCancel={this.dismissConfirmEnableFeatureDialog}
                            onDismiss={this.dismissConfirmEnableFeatureDialog}
                            title={strings.facial_recognition_enable_facial_ecognition_title}
                            submitButtonTitle={strings.action_enable}
                        >
                            <p>{strings.facial_recognition_enabled_warning_eula_intro} <a href={globals.eulaUrl + '#' + getCurrentLocale()} target="_blank" rel="noopener noreferrer">{strings.raven_eula_lable}</a>.</p>
                            <p>{strings.facial_recognition_please_ensure_you_are_in_compliance_with_local_laws_warning}</p>
                        </LegacyConfirmDialog>
                        {
                            updateInProgress && (
                                <div className='loading-overlay'>
                                    <ModalLoadingPage message={updateInProgress}/>
                                </div>
                            )
                        }
                    </div>
                </div>
            )
        }

        const makeFaceImagesArray = identitiesArray =>
            identitiesArray.map(({
                identityId,
                name,
                profileImageUrl,
            }) => ({
                name,
                src: profileImageUrl,
                key: identityId,
                width: 1,
                height: 1,
                selected: selectedFaceIds.includes(identityId),
            }));

        const knownFaceImages = makeFaceImagesArray(managedIdentitiesNamed);
        const unknownFaceImages = makeFaceImagesArray(managedIdentitiesUnnamed);
        const initialFetchInProgress = fetchInProgress && !unknownFaceImages.length && !knownFaceImages.length;

        const selectedFaces = (confirmMergeDialogOpen || confirmDeleteDialogOpen) ? [...managedIdentitiesNamed, ...managedIdentitiesUnnamed].filter(face => selectedFaceIds.includes(face.identityId)) : [];

        return (
            <div className="row" id="component_document_id_facial_recognition">
                <div className="col">
                    <h2>{title} <a href={BuildSettings.helpUrl('/fleet-managers-guide/#facial-recognition')} alt="Learn more about Facial Recognition" target="_blank" rel="noopener noreferrer"><i className="material-icons">help_outline</i></a></h2>
                </div>
                <div className="col-auto text-center">
                    {
                        featureEnabledChangePending ?
                            <span>...</span>
                            :
                            <span>{featureEnabled ? strings.settings_feature_enabled : strings.settings_feature_disabled}</span>
                    }
                    <Switch
                        onChange={() => this.updateFeatureEnabled(false)}
                        checked={featureEnabledChangePending ? !featureEnabled : featureEnabled}
                        disabled={featureEnabledChangePending}
                    />
                </div>
                <div className="col-12">
                    <div className="settings-section form-card">
                        <button disabled={fetchInProgress} onClick={this.onRefreshClick} className="btn-refresh">
                            <i className={"material-icons" + (fetchInProgress ? " icon-refresh-animate" : "")}>refresh</i>
                        </button>
                        <div className="alert alert-primary" role="alert">
                            {strings.facial_recognition_faces_description_introduction}
                        </div>
                        { !initialFetchInProgress &&
                                <>
                                <FaceGalleryRow
                                    title={strings.named_faces_title}
                                    images={knownFaceImages}
                                    onClickSelectAll={this.selectAllNamedFaces}
                                    onFaceClick={editMode ? this.onFaceClickEditMode : this.onFaceClickNormal}
                                    editMode={editMode}
                                />
                                <FaceGalleryRow
                                    title={strings.new_faces_title}
                                    images={unknownFaceImages}
                                    emptyPlaceholder={<p>{strings.faces_new_faces_empty_text}</p>}
                                    onFaceClick={editMode ? this.onFaceClickEditMode : this.onFaceClickNormal}
                                    onClickSelectAll={this.selectAllNewFaces}
                                    editMode={editMode}
                                />
                                </>
                        }
                        { errorMessage &&
                                <div className="alert alert-warning" role="alert">
                                    {errorMessage}
                                </div>
                        }
                        <ActionButtons
                            rendered={!initialFetchInProgress}
                            editMode={editMode}
                            toggleEditMode={this.toggleEditMode}
                            mergeEnabled={selectedFaceIds.length > 1}
                            onClickMerge={this.confirmMerge}
                            deleteEnabled={selectedFaceIds.length > 0}
                            onClickDelete={this.confirmDelete}
                        />
                        {
                            updateInProgress && (
                                <div className='loading-overlay'>
                                    <ModalLoadingPage message={updateInProgress}/>
                                </div>
                            )
                        }
                    </div>
                </div>

                <FaceDetailModal
                    user={this.props.user}
                    identityId={detailIdentityId}
                    progressMessage={actionStatus.progressMessage}
                    mergeIdentities={this.mergeIdentities}
                    setIdentityProfileFace={this.setIdentityProfileFace}
                    onRequestClose={this.closeFaceDetailModal}
                    onRequestSetName={this.setFaceName}
                    onRequestDeleteImages={this.deleteImages}
                    onRequestUnassignImages={this.unassignImages}
                />
                <DeleteDialog
                    isOpen={confirmDeleteDialogOpen}
                    onOk={this.deleteSelectedFaces}
                    onCancel={this.cancelDelete}
                    onDismiss={this.cancelDelete}
                    selectedFaces={selectedFaces}
                />
                <MergeDialog
                    isOpen={confirmMergeDialogOpen}
                    onOk={this.mergeFaces}
                    onCancel={this.cancelMerge}
                    onDismiss={this.cancelMerge}
                    facesToMerge={selectedFaces}
                />
            </div>
        )
    }
}

const ActionButtons = ({ rendered, editMode, ...props }) => {
    if (!rendered) return null;
    return editMode
        ? <EditModeButtons {...props} />
        : <NormalModeButtons {...props} />;
};

const EditModeButtons = ({
    toggleEditMode,
    mergeEnabled,
    onClickMerge,
    deleteEnabled,
    onClickDelete,
}) => (
    <div className="action-btns">
        <button className="btn" disabled={!deleteEnabled} onClick={onClickDelete}>
            <i className="material-icons">delete</i>
            {strings.faces_delete}
        </button>
        <button className="btn" disabled={!mergeEnabled} onClick={onClickMerge}>
            <i className="material-icons">merge_type</i>
            {strings.faces_merge}
        </button>
        <button className="btn" onClick={toggleEditMode}>
            <i className="material-icons">close</i>
            {strings.app_cancel}
        </button>
    </div>
);

const NormalModeButtons = ({ toggleEditMode }) => (
    <div className="action-btns">
        <button className="btn" onClick={toggleEditMode}>
            <i className="material-icons">edit</i>
            {strings.faces_edit}
        </button>
    </div>
);

const FaceGalleryRow = ({ title, images, emptyPlaceholder, editMode, onFaceClick, onClickSelectAll }) => {
    const hasImages = images && !!images.length;

    if (!hasImages && !emptyPlaceholder) return null;

    return (
        <div className="row align-items-center">
            <div className="col-auto">
                <h3>{title}</h3>
            </div>
            <div className="col">
                { (onClickSelectAll && editMode && hasImages) &&
                        <button type="button" className="btn btn-sm btn-outline-blue" onClick={onClickSelectAll}>{strings.faces_select_all}</button>
                }
            </div>
            <div className="col-12">
                {
                    hasImages ? (
                        <Gallery
                            photos={images}
                            onClick={(e, {index}) => onFaceClick(images[index].key)}
                            ImageComponent={editMode ? SelectablePhotoStack : PhotoStack}
                        />
                    ) : emptyPlaceholder
                }
            </div>
        </div>
    );
}

FacesSection.propTypes = {
    user: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        facialRecognitionEnabledSetting: SettingsSelectors.getSetting(state, 'account.facialRecognition.enabled'),
        fetchInProgress: identities.Selectors.fetchInProgress(state),
        errorMessage: identities.Selectors.errorMessage(state),
        managedIdentitiesNamed: identities.Selectors.managedIdentitiesNamed(state),
        managedIdentitiesUnnamed: identities.Selectors.managedIdentitiesUnnamed(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        changeFacialRecognitionEnabled: (stage, value) => dispatch(changeSetting(stage, 'account.facialRecognition.enabled', value)),
        loadAccountIdentities: stage => dispatch(identities.Actions.loadAccountIdentities(stage)),
        loadDetailedIdentity: (stage, identityId) => dispatch(identities.Actions.loadDetailedIdentity(stage, identityId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FacesSection);
